/* eslint-disable import/order */
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";

import "./assets/index.scss";

import { configureHttpClients, getUserManager, getApplyThemeHandler, getAppInfo } from "bootstrap";
import { App } from "App";
import { configureAuthenticationService } from "infrastructure/authentication";
import { loadStorage } from "infrastructure/store";
import { migrations } from "migrations";
import { appNotificationActions } from "ui/app";
import { userActions } from "ui/app/user-provider";

const applyThemeHandler = getApplyThemeHandler();
const userManager = getUserManager();

const storage = loadStorage(() => migrations, {
  actionProcessing: {
    ClearNotification: dispatch => {
      dispatch(appNotificationActions.clearScreenNotification());
      dispatch(appNotificationActions.clearAppNotification());
    }
  }
});

storage.getPersistor().subscribe(() => {
  const store = storage.getStore();

  applyThemeHandler(store.getState().settings.localSettings.theme);

  configureAuthenticationService(userManager, {
    onAccessTokenExpired: () => {
      store.dispatch(userActions.invalidSession());
    }
  });

  configureHttpClients(() => {
    store.dispatch(userActions.invalidSession());
  });
});

ReactDOM.render(<App appInfo={getAppInfo()} applyTheme={applyThemeHandler} storage={storage} />, document.getElementById("app"));
